export function UnlinkedChatbot() {
  return (
    <svg
      width="232"
      height="118"
      viewBox="0 0 232 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.36"
        y="99.9025"
        width="230.28"
        height="17.28"
        rx="1.64"
        stroke="#B5B2AA"
        strokeWidth="0.72"
      />
      <path
        d="M228.205 108.542L217.231 103.345L218.02 107.82L221.12 109.278V108.208L218.887 107.157L218.509 105.021L225.943 108.542L218.509 112.063L218.989 109.346L218.078 108.92L217.231 113.739L228.205 108.542Z"
        fill="#B5B2AA"
      />
      <path
        d="M38.0215 3.3667H153.021C156.059 3.3667 158.521 5.82913 158.521 8.8667V16.8667C158.521 19.9043 156.059 22.3667 153.021 22.3667H32.5215V8.8667C32.5215 5.82913 34.9839 3.3667 38.0215 3.3667Z"
        stroke="#B5B2AA"
      />
      <rect
        x="38.2242"
        y="10.6149"
        width="114.406"
        height="4.64944"
        rx="2.32472"
        fill="#D7D3C9"
      />
      <path
        d="M39.7607 34.3687H225.761C228.798 34.3687 231.261 36.8311 231.261 39.8687V53.3687H39.7607C36.7232 53.3687 34.2607 50.9062 34.2607 47.8687V39.8687C34.2607 36.8311 36.7232 34.3687 39.7607 34.3687Z"
        stroke="#B5B2AA"
      />
      <rect
        x="39.9634"
        y="41.6168"
        width="183.66"
        height="4.64944"
        rx="2.32472"
        fill="#D7D3C9"
      />
      <circle cx="13.1592" cy="12.941" r="12.3985" fill="#B5B2AA" />
      <path
        d="M11.9188 7.93182L10.5057 10.5238L10.2796 10.765L7.84959 12.2723L9.96177 13.5825L8.94391 14.4935L6.29211 12.8486V11.696L9.50827 9.70107L11.3785 6.27051H12.4591L14.3293 9.70107L17.5455 11.696V12.8486L14.3293 14.8435L12.4591 18.2741H11.3785L9.83266 15.4386L10.8045 14.5688L11.9188 16.6128L13.3319 14.0208L13.558 13.7796L15.988 12.2723L13.558 10.765L13.3319 10.5238L11.9188 7.93182Z"
        fill="#F5F3EB"
      />
      <path
        d="M18.6575 17.0682L17.8569 15.5997L17.0563 17.0682L15.6796 17.9222L17.0563 18.7761L17.8569 20.2446L18.6575 18.7761L20.0342 17.9222L18.6575 17.0682Z"
        fill="#F5F3EB"
      />
    </svg>
  );
}
